import camelize from "camelize";

interface ApiResponse<T = unknown> {
  data?: T;
  error?: string;
  errors?: Record<string, string[]>;
  message?: string;
}

export async function fetchWithCsrf<T>(
  url: string,
  options: RequestInit = {}
): Promise<T> {
  const csrfToken = document.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]'
  )?.content;

  const defaultHeaders: Record<string, string> =
    options.body instanceof FormData
      ? { "X-CSRF-Token": csrfToken || "" }
      : {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken || "",
        };

  const response = await fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers as Record<string, string>),
    },
  });

  const textResponse = await response.text();
  let data: ApiResponse;

  try {
    data = textResponse ? JSON.parse(textResponse) : {};
  } catch {
    throw new Error(`Failed to parse JSON response: ${textResponse}`);
  }

  const camelizedData = camelize(data);

  if (!response.ok) {
    throw camelizedData;
  }

  return camelizedData as T;
}
